module.exports = __webpack_public_path__ + "img/Questionnaire@2x.0b17c4ad.png";